import React from 'react';
import { Button } from 'shards-react';
import { useTranslation } from 'react-i18next';
import { CONDITION_STATUS, CONDITION_VIEW_MODES } from '../../../constants';
import type { ConditionViewMode, ConditionWithDetailTypeClient } from '../../../types/condition';

interface ConditionStatusActionProps {
  condition: ConditionWithDetailTypeClient | undefined;
  selectedViewMode: ConditionViewMode;
  onRequestApproval: () => void;
  onWithdrawEditing: () => void;
  onWithdrawRequest: () => void;
}

const ConditionActions = ({ condition, selectedViewMode, onRequestApproval, onWithdrawEditing, onWithdrawRequest }: ConditionStatusActionProps): React.ReactElement => {
  const { t } = useTranslation();
  const status: string | undefined = condition ? condition.conditionStatus : undefined;

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {selectedViewMode === CONDITION_VIEW_MODES.EDITING && status === CONDITION_STATUS.EDITING && (
        <div className="ml-2">
          <Button theme="primary" className="ml-2" onClick={onRequestApproval}>
            {t('condition.request.request')}
          </Button>
          <Button theme="primary" className="ml-2" onClick={onWithdrawEditing}>
            {t('condition.request.withdrawal')}
          </Button>
        </div>
      )}
      {selectedViewMode === CONDITION_VIEW_MODES.EDITING && status === CONDITION_STATUS.REQUEST && (
        <div className="ml-2">
          <Button theme="primary" className="ml-2" onClick={onWithdrawRequest}>
            {t('condition.request.withdrawal')}
          </Button>
        </div>
      )}
    </>
  );
};

export default ConditionActions;
